export enum InvoicePaymentStatus {
  PAID = 'opłacona',
  NOT_PAID = 'nieopłacona',
}
